<template>
  <div class="landing-page min-h-screen gradient-blue flex items-center justify-center px-4">
    <div class="w-full max-w-sm bg-blue-50 rounded-2xl shadow-lg overflow-hidden">
      <div class="flex flex-col items-center py-16">
        <div class="w-64 mb-12">
          <img src="@/assets/logo.png" alt="logo" class="w-full h-full object-contain">
        </div>
        <div class="w-full px-6">
          <button @click="goPage('/landing/platform')" :disabled="btnDisabled"  class="w-full flex items-center justify-center space-x-2 py-3 bg-gradient-to-r from-blue-500 to-cyan-500 text-white rounded-xl font-medium active:opacity-90 transition-opacity shadow-lg shadow-blue-500/30 mb-4">
              <i class="fa fa-user-o text-base"></i>
              <span>保理人端账号绑定</span>
          </button>
          <button @click="goPage('/landing/customer')":disabled="btnDisabled" class="w-full flex items-center justify-center space-x-2 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl font-medium active:opacity-90 transition-opacity shadow-lg shadow-blue-600/30">
            <i class="fa fa-building-o text-base"></i>
            <span>供应商端账号绑定</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
  import { ref, reactive, onMounted } from 'vue';
  import _service from '@/api/index'
  import { getUrlParam } from '@/common/utils'
  import { ElMessage } from 'element-plus'
  import { useRouter } from 'vue-router'
  const router = useRouter();

  const btnDisabled = ref(false);

  const goPage = (path) => {
    router.push(path);
  }

  onMounted(async () => {
    // let code = getUrlParam('code');
    // if(!code) {
    //   ElMessage.error('请从服务号入口进入');
    //   btnDisabled.value = true;
    //   return;
    // };
    // try {
    //   let res = await _service.getUserByCode({code});
    //   if(res) {}
    // } catch (error) {
    //   ElMessage.error('服务错误');
    //   btnDisabled.value = true;
    // }
  })
</script>